import { useAccount, useReadContract } from "wagmi";
import { USDT_CONTRACT_ADDRESS } from "../../../constants";
import { usdtAbi } from "../../../abis/usdtAbi";

export function useUSDTBalance() {
  const { address } = useAccount();
  const {
    data,
    error,
    isLoading,
    refetch: refetchUSDTBalance,
  } = useReadContract({
    address: USDT_CONTRACT_ADDRESS,
    abi: usdtAbi,
    functionName: "balanceOf",
    args: [address as `0x${string}`],
  });

  if (isLoading) return null;

  if (error) {
    console.log(error);
    return null;
  }

  if (data === undefined) return null;

  const usdtBalance = Number((data * BigInt(100)) / BigInt(10 ** 18)) / 100;

  return { usdtBalance, refetchUSDTBalance, isLoading };
}
